import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType, ref, useAttrs, watch } from 'vue'
import { getErrorMessage } from '@/helpers/error-helpers'
import LojaService from '../services/LojaService'

interface ObjetoDaSelecao {
	value: string
	text: string
	potencia: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SeletorDeLojas',
  props: {
	value: {
		default: null,
		type: [Object, String, Array] as PropType<ObjetoDaSelecao[] | ObjetoDaSelecao | null | string | string[]>,
	},
	potencia: { type: [String, Array] as PropType<string[] | string | undefined> },
},
  emits: ["input"],
  setup(__props, { emit }: { emit: ({
	(e: 'input', valor: ObjetoDaSelecao[] | string[] | null): void
}), expose: any, slots: any, attrs: any }) {

const props = __props;





const attrs = useAttrs()

const carregando = ref(true)
const erro = ref('')
const itens = ref<ObjetoDaSelecao[]>([])

async function carregarLojas() {
	carregando.value = true
	try {
		itens.value = (await LojaService.find())
			.map(({_id, nome, potencia}) => ({
				value: _id,
				text: nome,
				potencia: potencia.toString(),
			}))
	} catch (e) {
		erro.value = getErrorMessage(e)
	} finally {
		carregando.value = false
	}
}

carregarLojas()

const selecionado = computed((): ObjetoDaSelecao | ObjetoDaSelecao[] | null => {
	if (props.value === null || props.value === undefined) return null

	if (attrs.returnObject) return props.value as ObjetoDaSelecao | ObjetoDaSelecao[]

	const values = props.value as string | string[]

	if (Array.isArray(values)) {
		const selecionados = values.reduce<ObjetoDaSelecao[]>((selecionados, value) => {
			const loja = itens.value
				.find(item => item.value === value)

			return loja
				? [ ...selecionados, loja ]
				: selecionados
		}, [])
		return selecionados
	} else {
		const selecionado = itens.value
			.find((loja) => values === loja.value) || null
		return selecionado
	}
})

const lojasFiltradas = computed(() => {
	if (
		!props.potencia ||
		(Array.isArray(props.potencia) && !props.potencia.length)
	) return itens.value

	const potencia = props.potencia
	return Array.isArray(potencia)
		? itens.value.filter(item => potencia.includes(item.potencia))
		: itens.value.filter(item => potencia === item.potencia)
})

watch(() => props.potencia, (potencia) => {
	if (!potencia || !selecionado.value) return

	if (attrs.multiple !== undefined && attrs.multiple !== 'false') {
		const selecionados = selecionado.value as ObjetoDaSelecao[]
		const selecaoAtualizada = Array.isArray(potencia)
			? selecionados
				.filter((selecionado) => potencia.includes(selecionado.potencia))
			: selecionados
				.filter((selecionado) => potencia === selecionado.potencia)
		emit('input', attrs.returnObject
			? selecaoAtualizada
			: selecaoAtualizada.map(({ value }) => value),
		)
	} else {
		const atual = selecionado.value as ObjetoDaSelecao
		if (Array.isArray(potencia)) {
			if (potencia.includes(atual.potencia)) return
			emit('input', null)
		} else {
			if (potencia === atual.potencia) return
			emit('input', null)
		}
	}
})

return { __sfc: true,props, emit, attrs, carregando, erro, itens, carregarLojas, selecionado, lojasFiltradas }
}

})